import { Component } from '@angular/core';

@Component({
  selector: 'app-bi-emergency-stop',
  templateUrl: './bi-emergency-stop.component.html',
  styleUrls: ['./bi-emergency-stop.component.css']
})
export class BiEmergencyStopComponent {
}
